import { Button } from "@material-ui/core";
import { DataGrid, esES, GridOverlay } from "@mui/x-data-grid";
import { AlertModal } from "shared/components";
import { MENSAJE_REINTENTO_REFACTURACION } from "shared/utils/endosoTypes";
import {
  useColumnasRecibos,
  usePaginacionRecibos,
  useRefacturacion,
} from "../../hooks";
import useStyles from "./styles";

/**
 * Endoso 25 (HU6, iteración 2): tabla paginada server-side de recibos no
 * pagados del contratante, con selección acumulativa entre páginas.
 */
export const TablaRecibos = () => {
  const classes = useStyles();
  const {
    recibos,
    paginaRecibos,
    loaderRecibos,
    rowCount,
    recibosSeleccionados,
    cargarPagina,
    alternarRecibo,
    estaSeleccionado,
    seleccionarPagina,
    todosPaginaSeleccionados,
    algunoPaginaSeleccionado,
  } = usePaginacionRecibos();
  const columns = useColumnasRecibos({
    estaSeleccionado,
    alternarRecibo,
    seleccionarPagina,
    todosPaginaSeleccionados,
    algunoPaginaSeleccionado,
  });
  const {
    confirmarRefacturacion,
    showReintento,
    reintentarRefacturacion,
    rechazarReintento,
  } = useRefacturacion();

  return (
    <div className={classes.container}>
      <p className={classes.titulo}>
        Seleccione los recibos que desea refacturar
      </p>
      <p className={classes.contador}>
        Recibos seleccionados: {recibosSeleccionados.length}
      </p>
      <DataGrid
        /* autoHeight: el grid crece con sus filas en vez de scrollear dentro
         * de una altura fija (el card ya crece con el contenido). */
        autoHeight
        paginationMode="server"
        rowCount={rowCount}
        className={classes.root}
        page={paginaRecibos}
        pageSize={5}
        rowsPerPageOptions={[5]}
        disableColumnMenu
        /* La seleccion real es la columna de checkboxes propia
         * (recibosSeleccionados, acumulativa entre paginas). Se apaga la
         * seleccion nativa del grid para que el clic en una fila no la marque
         * ni el pie muestre un "N fila seleccionada" distinto al contador. */
        disableSelectionOnClick
        hideFooterSelectedRowCount
        columns={columns}
        rows={!loaderRecibos ? recibos : []}
        getRowId={(row) => row.uuid}
        onPageChange={(page) => cargarPagina(page)}
        loading={loaderRecibos}
        /* v4 expone el locale en props.MuiDataGrid.localeText; la ruta
         * components.defaultProps es de v5 y resolvía a undefined (pie en
         * inglés). Verificado contra @mui/x-data-grid 4.0.1. */
        localeText={esES?.props?.MuiDataGrid?.localeText}
        components={{
          NoRowsOverlay: () => (
            <GridOverlay>No se encontró información</GridOverlay>
          ),
        }}
      />
      <div className={classes.acciones}>
        <Button
          variant="contained"
          color="primary"
          disabled={recibosSeleccionados.length === 0 || loaderRecibos}
          onClick={confirmarRefacturacion}
        >
          Confirmar refacturación
        </Button>
      </div>
      {/* HU6 - reintentos: un único reintento ante cualquier error. */}
      <AlertModal
        open={showReintento}
        title="Atención"
        icon
        message={MENSAJE_REINTENTO_REFACTURACION}
        SuccessText="Sí"
        CancelText="No"
        success={reintentarRefacturacion}
        close={rechazarReintento}
        loading={loaderRecibos}
      />
    </div>
  );
};
